import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-funded',
  templateUrl: './funded.component.html',
  styleUrls: ['./funded.component.css']
})
export class FundedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
